import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Grid,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import clsx from 'clsx';
import { addDomain } from '../../redux/actions/managementActions';
import { updateUi } from '../../redux/actions/uiActions';
import { useSelector, useDispatch } from 'react-redux';
import { checkValidId } from '../../util/helpers/validation';
import LoadingButton from '../widgets/LoadingButton';
import { useIntl } from 'react-intl';
import { deburr, isObject } from 'lodash';

const useStyles = makeStyles((theme) => ({
  container: {
    ...theme.container(2),
    marginLeft: 0,
    maxWidth: '750px',
  },
  button: {
    margin: theme.spacing(2, 0, 2, 0),
  },
  title: {
    color: theme.palette.other.grey.dark,
    marginBottom: theme.spacing(2),
  },
  input: {
    marginBottom: theme.spacing(2),
  },
  horizontalFlex: {
    display: 'flex',
    flexDirection: 'row',
  },
  inputContainer: {
    marginBottom: theme.spacing(4),
  },
}));

export default function AddDomain(props) {
  const [domain, setDomain] = useState('');
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const intl = useIntl();

  const [copyDomainSettings, setCopyDomainSettings] = useState(false);
  const [domainSettingsToUse, setDomainSettingsToUse] = useState('');

  const { ui, profile } = useSelector(({ ui, firebase: { profile } }) => ({ ui, profile }));
  const hasDomainsCreated = profile.authDomains && profile.authDomains.length;

  const handleSubmit = (e) => {
    e.preventDefault();

    const error = checkValidId(domain);
    if (isObject(error)) {
      dispatch(
        updateUi({
          snackbar: {
            message: error,
            severity: 'error',
            show: true,
          },
        })
      );

      return;
    }

    dispatch(
      addDomain({
        domain,
        currentDomains: profile ? profile.authDomains : [],
        copyDomain: domainSettingsToUse,
      })
    );
  };

  return (
    <Container className={classes.container}>
      <form onSubmit={handleSubmit}>
        <Typography variant="h4" className={clsx(classes.title)}>
          {intl.formatMessage({ id: 'addDomain.title' })}
        </Typography>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.inputContainer}
        >
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              id="domain"
              name="domain"
              type="text"
              label={intl.formatMessage({ id: 'addDomain.input' })}
              value={domain}
              onChange={(e) => setDomain(deburr(e.target.value))}
              className={classes.input}
              autoFocus
            />
          </Grid>
          <Grid item sm={8} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={copyDomainSettings}
                  onChange={(e) => setCopyDomainSettings(e.target.checked)}
                  disabled={!hasDomainsCreated}
                />
              }
              label={
                <Typography variant="body2">{intl.formatMessage({ id: 'addDomain.copyDomainSettings' })}</Typography>
              }
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            {hasDomainsCreated && copyDomainSettings ? (
              <FormControl fullWidth>
                <InputLabel id="domain-label">{intl.formatMessage({ id: 'domain' })}</InputLabel>
                <Select
                  labelId="domain-label"
                  id="domain"
                  value={domainSettingsToUse}
                  onChange={(e) => setDomainSettingsToUse(e.target.value)}
                  style={{ marginBottom: theme.spacing(2) }}
                >
                  {[...profile.authDomains].sort().map((domain) => (
                    <MenuItem key={domain} value={domain}>
                      {domain}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null}
          </Grid>
        </Grid>

        <LoadingButton
          isLoading={ui.loadingButton.isAddDomainLoading}
          content={intl.formatMessage({ id: 'addDomain.title' })}
          type="submit"
        />
      </form>
    </Container>
  );
}
